import React, { useEffect, useState } from "react";
import HomeBannerAbout from "./HomeBannerAbout";
import { fetchbannerlistmo } from "../services/HomeBannerMobilelist";
import { fetchbannerlistdesk } from "../services/HomeBannerdesklist";
import { API_BASE } from "../api/apiConfig";

export default function HomeBanner() {
  const [showAbout, setShowAbout] = useState(false);
  const [cards, setCards] = useState([]);
  const [activeCard, setActiveCard] = useState(0);

  // Icons (React-safe SVG)
  const GraduationIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6" />
      <path d="M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
  );

  const UsersIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );

  const GlobeIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 2a14.5 14.5 0 0 0 0 20" />
      <path d="M2 12h20" />
    </svg>
  );

  // Config Map
  /*const configMap = {
    travel_stories: {
      icon: <GraduationIcon />,
      subtitle: "Skill-Building",
      cta: "Learn While You Travel",
      href: "/ExperienceTrips",
    },
    local_experts: {
      icon: <UsersIcon />,
      subtitle: "Adventures",
      cta: "Find Your Tribe",
      href: "/grouptrips",
    },
    community: {
      icon: <GlobeIcon />,
      subtitle: "Free to Join",
      cta: "Connect Locally",
      href: "/community",
    },
  };*/

  const configMap = {
    "Skill-Building": {
      icon: <GraduationIcon />,
      subtitle: "Skill-Building",
      cta: "Learn While You Travel",
      href: "/ExperienceTrips",
    },
    "Adventures": {
      icon: <UsersIcon />,
      subtitle: "Adventures",
      cta: "Find Your Tribe",
      href: "/grouptrips",
    },
    "Free to Join": {
      icon: <GlobeIcon />,
      subtitle: "Free to Join",
      cta: "Connect Locally",
      href: "/community",
    },
  };

  // API Load
  useEffect(() => {
    const loadBanners = async () => {
      const isMobile = window.innerWidth < 1024;

      const res = isMobile
        ? await fetchbannerlistmo()
        : await fetchbannerlistdesk();

      if (res?.status && Array.isArray(res.data)) {
        /*const keys = Object.keys(configMap);*/

        /*const formatted = res.data.slice(0, 3).map((item, index) => {
          const key = item.type || keys[index];
          const config = configMap[key] || {};*/
        const formatted = res.data
        .filter(item => configMap[item.page_name])
        .map((item) => {
          const config = configMap[item.page_name];

          return {
            id: item.id,
            title: item.heading,
            desc: item.paragraph,
            img: `${API_BASE}/${item.banner_img}`,
            ...config,
          };
        });

        setCards(formatted);
      }
    };

    loadBanners();
  }, []);

  if (!cards.length) return null;

  const currentCard = cards[activeCard] || {};

  return (
    <div className="lg:hidden relative">
      <div className="relative h-[calc(100dvh-7rem)] overflow-hidden">

        {/* Background Images */}
        {cards.map((card, index) => (
          <div
            key={card.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              activeCard === index ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={card.img}
              alt={card.title}
              className="w-full h-full object-cover"
            />
          </div>
        ))}

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/60 via-transparent to-slate-950/90" />

        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-between px-4 py-4">

          {/* Heading */}
          <div>
            <div className="mb-3">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur border border-white/20">
                <span className="w-2 h-2 bg-primary rounded-full animate-pulse" />
                <span className="text-xs text-white">India's Travel Community</span>
              </div>
            </div>

            <h1 className="text-white text-xl font-bold leading-tight">
              Every Connecting Traveller <br />
              trip will teach you <br />
              <span className="text-primary">something new.</span>
            </h1>
          </div>

          {/* Active Card */}
          <div>
            <a href={currentCard.href} className="block mb-4">

              <div className="flex items-center gap-2 mb-2">
                <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary text-white">
                  {currentCard.icon}
                </div>
                <span className="text-xs text-white/70 uppercase">
                  {currentCard.subtitle}
                </span>
              </div>

              <h3 className="text-white text-lg font-bold mb-1">
                {currentCard.title}
              </h3>

              <p className="text-white/60 text-sm line-clamp-2">
                {currentCard.desc}
              </p>

              <div className="mt-3 inline-flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-full text-sm font-semibold">
                {currentCard.cta} →
              </div>
            </a>

            {/* Dots */}
            <div className="flex justify-center gap-2 mb-3">
              {cards.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveCard(index)}
                  className={`rounded-full transition-all ${
                    activeCard === index
                      ? "w-6 h-2 bg-primary"
                      : "w-2 h-2 bg-white/40"
                  }`}
                />
              ))}
            </div>

            {/* Tabs */}
            <div className="flex gap-2 mb-3">
              {cards.map((card, index) => (
                <button
                  key={index}
                  onClick={() => setActiveCard(index)}
                  className={`flex-1 py-2 rounded-full text-xs font-semibold transition ${
                    activeCard === index
                      ? "bg-white text-black"
                      : "bg-white/20 text-white"
                  }`}
                >
                  {card.title}
                </button>
              ))}
            </div>

            {/* About */}
            <button
              onClick={() => setShowAbout(true)}
              className="w-full py-2 rounded-full bg-white/10 border border-white/20 text-white text-xs"
            >
              Know about us →
            </button>

            {showAbout && (
              <HomeBannerAbout onClose={() => setShowAbout(false)} />
            )}
          </div>

        </div>
      </div>
    </div>
  );
}